import React, { Component } from 'react';
import { string, bool, func } from 'prop-types';
import ReactDOM from 'react-dom';

import { getVideoUrl } from '@blueberry/utils/youtube';

// [ref](https://developers.google.com/youtube/player_parameters#Parameters)

class YoutubeVideo extends Component {
  static propTypes = {
    videoId: string.isRequired,
    videoUrl: string.isRequired,
    autohide: bool,
    autoplay: bool,
    className: string,
    getDurationTime: func,
    id: string,
    isMute: bool,
    loop: bool,
    playlist: string,
  };

  static defaultProps = {
    autoplay: false,
    autohide: true,
    loop: false,
    getDurationTime: () => {},
    id: '',
    isMute: true,
    className: '',
    playlist: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
  }

  componentDidMount() {
    this.setWidth();

    window.addEventListener('resize', this.setWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setWidth);
  }

  setWidth = () => {
    const { width } = ReactDOM.findDOMNode(this).getBoundingClientRect();

    this.setState({
      width,
    });
  };

  convertBoolean2Binary(val) {
    return val ? 1 : 0;
  }

  render() {
    const {
      autoplay,
      autohide,
      className,
      videoId,
      videoUrl,
      playlist,
    } = this.props;
    const { width } = this.state;
    const config = {
      enablejsapi: 1,
      rel: 0,
      showinfo: 0,
      mute: this.convertBoolean2Binary(autoplay),
      autoplay: this.convertBoolean2Binary(autoplay),
      autohide: this.convertBoolean2Binary(autohide),
      loop: this.convertBoolean2Binary(playlist),
      playlist,
    };
    const style = {
      width: '100%',
      // 0.43 is 330/768, this number from designer
      // avoiding shadow have 1px white only get integer
      height: Math.ceil((width * 9) / 16),
    };

    const url = getVideoUrl(config)(videoUrl);

    return (
      <div className={className}>
        <iframe
          scrolling="no"
          src={url}
          frameBorder="0"
          id={videoId}
          allowFullScreen
          style={style}
        />
      </div>
    );
  }
}

export default YoutubeVideo;



// WEBPACK FOOTER //
// ./app/components/YoutubeVideo/YoutubeVideo.jsx